import { ApiFunusIps } from './types';
import axios from 'config/axios';

export const ips: ApiFunusIps = {
  getIps: () => axios.get('/televisions'),
  editIp: ({ id, values }) => axios.put(`/television/${id}`, values),
  getIpById: (id) => axios.get(`/television/${id}`),
  saveIp: (params) => axios.post('/television', params),
};
